/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";
import { getGohonzonType } from "../../utils";

function GohonzonOmamoriAllotment({
  member,
  onRejectApplication,
  onMemberSelect,
  allotApplication,
}) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={{ ...style.Cell, maxWidth: "150px" }}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.regionName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon
            onClick={() => onMemberSelect(member.memberId, `allotment/preview`)}
            style={style.icon}
          />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              variant="outlined"
              disabled={!(member.status === "FINAL_INTERVIEWED")}
              style={{
                ...style.actionBtn,
                width: "80px",
                marginBottom: "10px",
              }}
              onClick={() => allotApplication(member)}
              label="ALLOT"
            />
            <Button
              variant="outlined"
              disabled={!(member.status === "FINAL_INTERVIEWED")}
              onClick={() => onRejectApplication(member)}
              style={{ ...style.actionBtn, width: "80px" }}
              label="CANCEL"
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonOmamoriAllotment;
